import { useQuery, useQueryClient } from "@tanstack/react-query";

import { Dataset } from "@nens/rana/api-v1";
import { getRanaApiV1 } from "@nens/rana/api-v1";

import { ensureObjectUrlCleanup } from "./utils/ensure-object-url-cleanup";

// Single

const getDatasetThumbnail = (dataset: Dataset) => {
  const url = dataset.overview?.[0]?.url;

  return getRanaApiV1().getQueryOptions({
    queryKey: ["dataset", "thumbnail", url],
    queryFn: async () => {
      if (!dataset) throw Error("Never happens");

      if (!url) return null;

      // If tumbnail is an external url, use that directly
      if (url.startsWith("http")) return url;

      // If thumbnail is not an external url, fetch it from the API
      const response = await getRanaApiV1().DatasetsApi.datasetThumbnailRetrieve({
        datasetId: dataset.id,
      });

      if (!response) return null;

      return URL.createObjectURL(response);
    },
    enabled: !!dataset,
  });
};

export const useDatasetThumbnailQuery = (dataset: Dataset) => {
  const queryClient = useQueryClient();
  ensureObjectUrlCleanup({
    queryClient,
    queryKeyPrefix: getDatasetThumbnail(dataset).queryKey.slice(0, -1),
    subscriptionKey: "dataset-thumbnail-url-cleanup",
  });
  return useQuery(getDatasetThumbnail(dataset));
};
